import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { BurdenContainerComponent } from './burden-container/burden-container.component';
const log = new LoggingService();

export const BurdenRoute: Ng2StateDeclaration = {
    // name: 'Burden.**'
    name: 'burden',
    url: '/burden',
    // , loadChildren: () => import('./burden.module').then(r => r.BurdenModule)
    data: { requiresAuth: true },

    component: BurdenContainerComponent
};
